import { render, staticRenderFns } from "./todosDesafios.vue?vue&type=template&id=b06d5aca&"
import script from "./todosDesafios.vue?vue&type=script&lang=js&"
export * from "./todosDesafios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports